import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import React from "react";
import PropTypes from "prop-types";
import Button from "../basic-button/basic-button";
import { MessageType } from "../../../Constant";

function ConfirmationModal(props) {
  const {
    messageCallBack, showModal, title, content, yesButtonText,
  } = props;
  return (
    <Dialog
      onClose={() => messageCallBack(null, null)}
      aria-labelledby="customized-dialog-title"
      open={showModal}
      className="confirmationModal"
    >
      <DialogTitle id="customized-dialog-title" onClose={() => messageCallBack(null, null)}>
        <div className="modalHeaderWrapper">
          <div className="dialogTitle">
            {title}
            {" "}
          </div>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        <div>
          {content}
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          classname="backBtnContainer"
          onClick={() => { messageCallBack(null, null); }}
          buttonText="Cancel"
        />
        <Button
          classname="submitBtnContainer"
          onClick={() => {
            messageCallBack(MessageType.SUCCESS, null);
          }}
          buttonText={yesButtonText || "Yes"}
        />
      </DialogActions>
    </Dialog>
  );
}

ConfirmationModal.defaultProps = {
  title: "",
  content: "",
  showModal: false,
  onClick: () => {
    // onClick
  },
};
ConfirmationModal.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  showModal: PropTypes.bool,
  onClick: PropTypes.func,
};
export default ConfirmationModal;
